<template>
  <div>
    <v-dialog v-model="show_dialog_box" max-width="550px">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" class="text-capitalize light--text font-weight-bold" color="primary" @click="onShow"><v-icon small class="me-1">mdi-plus</v-icon> Add</v-btn>
      </template>
      <v-card class="pa-3" color="pop_bg">
        <v-row>
          <v-card-title class="dark--text text-h6 mt-n2 ms-2">Add API User</v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="dark" text @click="close"><v-icon>mdi-close</v-icon></v-btn>
        </v-row>
        <v-divider></v-divider>

        <v-card-text>
          <v-container class="mt-2">
            <!-- <h3 class="ms-sm-8">Enter Contact Method Details</h3> -->
            <v-form @submit="createContactMethod()" v-model="valid" ref="form">
              <v-layout wrap>
                <v-flex xs12 sm5>
                  <h4 class="text-body-2 dark--text">Name</h4>
                </v-flex>
                <v-flex xs12 sm7 md6>
                  <v-text-field v-model="firstnameEn" :rules="[requiredValidator('firstname')]" solo dense></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm5>
                  <h4 class="text-body-2 dark--text">Phone</h4>
                </v-flex>
                <v-flex xs12 sm7 md6>
                  <v-text-field
                    class="inputPhone"
                    solo
                    dense
                    :counter="8"
                    type="number"
                    v-model="phone"
                    @keypress="isNumber"
                    :rules="[requiredValidator('phone'), minLengthValidator('phone', 8), maxLengthValidator('phone', 8), this.doesPhoneExist != true || 'phone already exists.']"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout wrap>
                <v-flex xs12 sm5>
                  <h4 class="text-body-2 dark--text">API Key</h4>
                </v-flex>
                <v-flex xs12 sm7 md6>
                  <v-text-field v-model="apiKey" :rules="[requiredValidator('apiKey')]" solo :disabled="true" dense></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row justify-end class="mt-5">
                <v-btn :width="$vuetify.breakpoint.smAndUp ? 120 : 90" color="primary" class=" text-capitalize" @click="createContactMethod()" :loading="btnloading" :disabled="!valid">Save</v-btn>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" timeout="3000" right top color="success">{{ text }}</v-snackbar>
  </div>
</template>

<script>
import { requiredValidator, minLengthValidator, maxLengthValidator } from "../../core/methods/validations";
export default {
  components: {},
  data() {
    return {
      requiredValidator,
      maxLengthValidator,
      minLengthValidator,
      phone: "",
      apiKey: "",
      firstnameEn: "",
      btnloading: false,
      valid: true,
      errors: [],
      snackbar: false,
      text: "",
      show_dialog_box: false,
    };
  },
  methods: {
    getRandomString() {
      var result = "";
      let chars = "0123456789abcdefghijklmnopqrstuvwxyz";
      for (var i = 12; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
      return result;
    },
    onShow() {
      this.apiKey = this.getRandomString();
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    createContactMethod() {
      this.btnloading = true;
      this.$apollo
        .mutate({
          mutation: require("@/api-user/api/createAPIUser.graphql"),
          variables: {
            phone: this.phone,
            firstnameEn: this.firstnameEn,
            apiKey: this.apiKey,
            lastnameEn: "-",
          },
          update: (store, { data: { createAPIUser } }) => {
            try {
              const query = {
                query: require("@/api-user/api/getAllAPIUsers.graphql"),
              };

              let allContactMethods = store.readQuery(query);
              allContactMethods.getAllAPIUsers.users.unshift(createAPIUser); //push to top
              store.writeQuery({
                ...query,
                data: allContactMethods,
              });
              this.text = "Api user Added";
              this.snackbar = true;
              this.show_dialog_box = false;
            } catch (e) {
              // console.log(e);
              console.log("Something bad happend- CategoryForm.vue");
            }
            this.$refs.form.reset();
            this.btnloading = false;
          },
        })
        .then(() => {
          this.$root.$emit("updateMethods");
        })
        .catch(error => {
          if (error.graphQLErrors != null) {
            console.error(error.graphQLErrors);
          }
          this.btnloading = false;
        });
    },
    close() {
      this.show_dialog_box = false;
    },
  },
};
</script>
